import React, { useState, useContext, useEffect } from 'react'
import { Button } from '@material-ui/core'
import './Footer.css'
import AutopltContext from '@/product/context/autopilot/autopltContext'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { LOGO, SITE_NAME } from '@/utils'
import { mapData } from '@/product/common/components'
import { Link } from 'react-router-dom'

const Footer = () => {
    const autopltContext = useContext(AutopltContext)

    const { addCustomer, responseStatus: responseStatusAutoPlt } = autopltContext

    const validationArray = Yup.object({
        email: Yup.string().email('Invalid email format').required('Required'),
    })

    const formik = useFormik({
        initialValues: {
            email: '',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            addCustomer(values)
        },
    })

    const subscribe = [
        {
            label: 'Subscribe to our mailing list',
            placeholder: 'Enter your email address',
            class: 'subsInp',
            type: 'text',
            variant: 'filled',
            name: 'email',
            formik: formik,
        },
    ]

    useEffect(() => {
        if (responseStatusAutoPlt) {
            if (responseStatusAutoPlt.from === 'addCustomer') {
                if (responseStatusAutoPlt.status === 'success') {
                    formik.values.email = ''
                }
            }
        }
    }, [responseStatusAutoPlt])

    return (
        <footer className="noPrint">
            <div className="footCnt ">
                <div className="customContainer d-flex justify-content-center align-items-center flex-wrap h-100">
                    <div className="footLinks pt-4">
                        <ul>
                            <li>
                                <Link id="footer_home" to="/">
                                    {'Home'}
                                </Link>
                            </li>
                            <li>
                                <Link id="footer_about" to="/about">
                                    {'About'}
                                </Link>
                            </li>
                            <li>
                                <Link id="footer_guidelines" to="/guidelines">
                                    {'Guidelines'}
                                </Link>
                            </li>
                            <li>
                                <Link id="footer_contact" to="/contact">
                                    {'Contact'}
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <p className="footCopyright text-center px-4" dir="ltr">
                    © {SITE_NAME} {new Date().getFullYear()}.{'All rights reserved'}
                </p>
            </div>
        </footer>
    )
}

export default Footer
